module.exports = __webpack_public_path__ + "media/s3Model3.f30752c2.mp4";